(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sealbits-review-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const css = `
    .wrapper{background:#fff!important;box-shadow:none!important;border:0!important;border-radius:0!important}
    .element{gap:14px;padding:8px 22px 8px 0;align-items:flex-start;font-family:inherit}
    .image{width:48px;height:48px;flex:0 0 48px;border-radius:50%!important;object-fit:cover}
    .content{min-height:58px;gap:8px;justify-content:flex-start;overflow:visible}
    .text{order:0;font-size:14px;line-height:1.55;color:#243c3c;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
    .title{order:1;display:flex;align-items:center;gap:10px;flex-wrap:wrap}
    .name{font-size:12px;font-weight:400!important;color:#687b7b}
    .rating{display:inline-flex;gap:2px;color:#d39b23}
    .rating svg{width:14px;height:14px;fill:#d39b23}
    .arrow{box-shadow:none!important;color:#035251;background:#fff}
    .arrow.right{right:0}
    .arrow.left{left:-10px}
    .sb-review-dots{display:flex;gap:2px;justify-content:center;align-items:center;margin-top:4px}
    .sb-review-dot{display:grid;place-items:center;width:22px;height:22px;border:0;padding:0;background:transparent;cursor:pointer}
    .sb-review-dot::before{content:"";width:6px;height:6px;border-radius:50%;background:#c6d7d6}
    .sb-review-dot[aria-current="true"]::before{background:#035251}
    .sb-review-dot:focus-visible{outline:2px solid #035251;outline-offset:0;border-radius:50%}
    @media(max-width:480px){.element{gap:11px}.text{font-size:13px}.image{width:44px;height:44px;flex-basis:44px}}
    @media(prefers-reduced-motion:reduce){.grid{scroll-behavior:auto!important}}
  `;
  const installed = new WeakSet();
  function install() {
    if (!document.querySelector('[data-sb-review-style]')) return;
    document.querySelectorAll('.product__info-container loox-snippets-widget').forEach(host => {
      const root = host.shadowRoot;
      if (!root || installed.has(host)) return;
      installed.add(host);
      const apply = () => {
        if (!root.querySelector('[data-sb-review-css]')) {
          const style = document.createElement('style');
          style.dataset.sbReviewCss = '';
          style.textContent = css;
          root.appendChild(style);
        }
        const grid = root.querySelector('.grid');
        const container = root.querySelector('.container');
        if (!grid || !container || root.querySelector('.sb-review-dots')) return;
        const slides = Array.from(grid.querySelectorAll('.quickview-button'));
        if (slides.length < 2) return;
        const bar = document.createElement('div');
        bar.className = 'sb-review-dots';
        const label = document.querySelector('[data-sb-review-style]').dataset.label;
        slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'sb-review-dot';
          dot.setAttribute('aria-label', label.replace('[number]', index + 1));
          dot.addEventListener('click', () => grid.scrollTo({
            left: slide.offsetLeft - slides[0].offsetLeft,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          }));
          bar.appendChild(dot);
        });
        container.appendChild(bar);
        const update = () => {
          const current = slides.reduce((nearest, slide, index) => Math.abs(slide.offsetLeft - slides[0].offsetLeft - grid.scrollLeft) < Math.abs(slides[nearest].offsetLeft - slides[0].offsetLeft - grid.scrollLeft) ? index : nearest, 0);
          Array.from(bar.children).forEach((dot, index) => dot.setAttribute('aria-current', String(index === Math.max(0, current))));
        };
        grid.addEventListener('scroll', update, { passive: true });
        new MutationObserver(update).observe(grid, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
        update();
      };
      apply();
      new MutationObserver(apply).observe(root, { childList: true, subtree: true });
    });
  }
  install();
  customElements.whenDefined('loox-snippets-widget').then(install);
  new MutationObserver(install).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', install);
})();
  } catch(e) { console.error(e); }
})();

})();
